import React from 'react';
import { Button, Modal, Text } from '@fragments';
import { IconArrowUpRight, IconBrandWhatsapp } from '@tabler/icons-react';
import './styles.scss';

// Cancelling goes through support: this dialog says so and opens the support WhatsApp with
// the plan and the account already in the message. Nothing is cancelled from here.
export default function CancelDialog({ studio: s, page }) {
  const { t } = s;
  const plan = t(`planName_${s.payments.plan}`);
  return <Modal open size={440} closeLabel={t('close')} onClose={page.closeCancel} title={t('billingCancelTitle', { plan })} className="studio-dialog studio-cancel-dialog"
    footer={<div className="studio-cancel-dialog__actions">
      <Button variant="rounded" color="overlay" preventLoading onClick={page.closeCancel}>{t('billingCancelKeep')}</Button>
      <Button variant="rounded" color="inverse" preventLoading startIcon={<IconBrandWhatsapp />} endIcon={<IconArrowUpRight />} onClick={page.contactSupport}>{t('billingCancelSupportCta')}</Button>
    </div>}>
    <Text.p contrast={7}>{t('billingCancelSupportText', { plan })}</Text.p>
    <div className="studio-cancel-dialog__phone">
      <IconBrandWhatsapp aria-hidden="true" />
      <div>
        <Text.caption contrast={6}>{t('billingCancelSupportPhone')}</Text.caption>
        <Text.label contrast={9}>{page.supportPhone}</Text.label>
      </div>
    </div>
  </Modal>;
}
